export default __webpack_public_path__ + "static/media/threeBoxes.b3e0ca8d.svg";